module.exports = __webpack_public_path__ + "img/returnaudit.c5a577f0.png";